<template>
  <v-alert
  :type="alertType"
  class="text-white">
    {{ actual }} mins
    <span style="font-size: smaller; float: right">({{ min }} - {{ max }})</span>
  </v-alert>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'ColouredValueTime',
  props: ['value', 'start', 'end', 'min', 'max'],
  computed: {
    actual() {
      const { start, end } = this;
      const date1 = dayjs(`1900-01-01 ${start}`);
      const date2 = dayjs(`1900-01-01 ${end}`);
      return date2.diff(date1, 'minute');
    },
    // formattedValue() {
    //   const result = this.actual?.toFixed(2) ?? 0;
    //   if (result === 'NaN') {
    //     return 0;
    //   }
    //   return result;
    // },
    isSuccess() {
      return this.actual >= this.min && this.actual <= this.max;
    },
    isError() {
      return this.actual < this.min || this.actual > this.max;
    },
    alertType() {
      if (this.isSuccess) {
        return 'success';
      }
      return 'error';
    },
  },
};
</script>
<style scoped>
.text-success {
  color: green;
}
.text-error {
  color: red;
}
</style>
